<template>
  <div>
    <h1 class="text-center text-base text-3-3/4 text-wine font-site">{{ title }}</h1>
    <h2 v-if="subtitle" class="text-center text-base text-2xl text-wine-light">
      {{ subtitle }}
    </h2>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.text-3-3\/4 {
  font-size: 3.75rem;
}
</style>
